import React from 'react';

export const Slat25mm = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g
        fill="#fff"
        stroke="#233762"
        strokeWidth={4.853}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        clipPath="url(#prefix__b)"
      >
        <path d="M-12 85.3s62.4 6 69.4 6.7c7 .7 7.4.8 9-3.3 1.6-4.1 2.9-6.1 3.6-7.2.8-1.2 1.8-2.6-2.4-2.9S-12 71.7-12 71.7v13.6z" />
        <path d="M-12 71.8s62.4 6 69.4 6.7c7 .7 7.4.8 9-3.3 1.6-4.1 2.9-6.1 3.6-7.2.8-1.2 1.8-2.6-2.4-2.9s-79.6-7-79.6-7v13.7z" />
        <path d="M-12 58.6s62.4 6 69.4 6.7 7.4.8 9-3.3 2.9-6.1 3.6-7.2c.8-1.2 1.8-2.6-2.4-2.9S-12 45-12 45v13.6z" />
        <path d="M-12 45.3s62.4 6 69.4 6.7 7.4.8 9-3.3 2.9-6.1 3.6-7.2c.8-1.2 1.8-2.6-2.4-2.9S-12 31.7-12 31.7v13.6z" />
        <path d="M-12 31.9c59.9 5.9 59.9 5.9 68.2 6.7 7 .7 7.4.8 9-3.3s2.9-6.1 3.6-7.2c.8-1.2 1.8-2.6-2.4-2.9-4.1-.4-78.4-6.9-78.4-6.9v13.6z" />
        <path d="M-12 18.9s61.2 6 68.2 6.7c7 .7 7.4.8 9-3.3s2.9-6.1 3.6-7.2 1.8-2.6-2.4-2.9c-4.1-.4-78.4-7-78.4-7v13.7z" />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
